<template>
  <div>
    <van-nav-bar
      title="追加保证金"
      left-text=""
      left-arrow
      @click-left="$router.push('/account_details')"
    />
    <van-form>
      <van-cell title="合约编号">
        <template #default>
          <span>{{ order }}</span>
        </template>
      </van-cell>
      <van-row>
          <van-col span="24" class="divideSection"> 
              <span>当前总账户余额 ：{{cash}}港元</span><br>
          </van-col>
      </van-row>
      <van-cell title="当前余额">
        <template #default>
          <span>{{ total }}港元</span>
        </template>
      </van-cell>
      <van-row>
        <van-col span="20">
          <van-field
            v-model="addBondMoney"
            type="digit"
            placeholder="请输入追加金额 最低100港元起"
            input-align="right"
          >
            <template #label>
              <div style="width: 150px;">追加保证金金额</div> 
            </template>
          </van-field>
        </van-col>
        <van-col span="4"> 
          <van-cell title="港元">
          <template #title>
              <div style="text-align:right;"><span>港元</span></div>
            </template>
          </van-cell>
        </van-col>
      </van-row>
      <van-row>
          <van-col span="24" class="divideSection"> 
              <span>追加后总账户余额 ：{{availableCash}}港元</span><br>
          </van-col>
      </van-row>
      <van-row style="padding: 10px"
        ><van-col span="8" style="text-align: right"
          ><van-icon
            name="warning"
            size="25px"
            color="red"
            style="padding-right: 10px" /></van-col
        ><van-col span="16" style="color: #969799; font-size: 14px">
          最低追加金额{{minBond}}港元</van-col
        >
      </van-row>
      <van-button size="small" type="danger" block @click="operationBondAdd()"
        >立即追加</van-button
      >
    </van-form>
    <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24"  />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "IncreaseCapitalInfo",
  data() {
    return {
      loadingMask: false,
      minBond:"0.00",
      availableCash:"0.00",
      cash: "0.00", 
      cid: sessionStorage.getItem("cid"),
      order: 0,
      total: 0,
      balance: "0.00", //余额
      minBondAdd: "", //最低追保证金金额
      addBondMoney: "", //追加保证金 金额
    };
  },
  watch:{
    addBondMoney: function (value){
          if(value){
              //main balance after add values
              let cash = (parseFloat(this.cash) - parseFloat(value));
              this.availableCash = parseFloat(cash).toFixed(2);
          }else{
               this.availableCash = parseFloat(this.cash).toFixed(2);
          }
    }
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    //追加履约金 - 显示
    showBondAdd() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_bond_info",
            token: sessionStorage.getItem("token"),
            cid: that.cid,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.balance = res.data.data.total;
            that.minBondAdd = res.data.data.min_bond;
            that.cash = res.data.data.cash;
            that.availableCash = that.cash;
            that.minBond = res.data.data.min_bond;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    //追加履约金 - 操作
    operationBondAdd() {
      let that = this;
      if (that.addBondMoney == "") {
        that.$toast.fail("请输入追加金额");
      } else {
        that.loadingMask = true;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_bond_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addBondMoney,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.addBondMoney = "";
              that.$toast({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose: function () {
                  that.$router.push({
                    path: "/account_details",
                  });
                },
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          }).finally(() => {
              that.loadingMask = false;
          });
      }
    },
  },
  mounted: function () {
    this.isLogin();
    this.showBondAdd();
    this.total = this.$route.params.total;
    this.order = this.$route.params.order;
  },
};
</script>

<style scoped>
.divideSection {
  height: 30px; 
  background: #f1f1f1;
  border-top: 1px solid #f2f3f5;
  border-bottom: 1px solid #f2f3f5;
  padding-top: 5px;
  padding-left: 16px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/IncreaseBondInfo.vue